<app-lfsa-card-v2 *ngIf="!mostrarFormulario" [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplate"
                  [modulo]="DAT_TITULOS.modulo" [tituloCard]="titulo" [titulo]="DAT_TITULOS.titulo">
</app-lfsa-card-v2>
<ng-template #innTemplateButton>
</ng-template>
<ng-template #enviarTemplate>
  <!-- <br> -->
  <section class="section">
    <div class="row">
      <div class="col-md-12 ">
        <app-lfsa-alerts [listaVacia]="listaVacia" [loading]="loading"
                         [texto]="DAT_TITULOS.listaVacia"></app-lfsa-alerts>
        <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" *ngIf="!listaVacia"
                         [columnDefs]="columnDefs" [floatingFilter]="true" [frameworkComponents]="frameworkComponents " [localeText]="AG_GRID_LOCALE_ES"
                         [pagination]="true"
                         [rowData]="rowData" [rowSelection]="rowSelection" [style]="modulo.agGrid.style"
                         class="ag-theme-alpine" [paginationPageSize]="modulo.agGrid.paginacion">
        </ag-grid-angular>
      </div>
    </div>
  </section>
</ng-template>

<app-lfsa-card-v2 *ngIf="mostrarFormulario" [innTemplate]="enviarTemplateForm" [modulo]="DAT_TITULOS.modulo"
                  [tituloCard]="titulo" [titulo]="DAT_TITULOS.titulo">
</app-lfsa-card-v2>
<ng-template #enviarTemplateForm>
  <form [formGroup]="formulario" class="form-group" novalidate>
    <div class="row">
      <div class="form-group col-md-4 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('colorReferencia')" [id]="'colorReferencia'"
                        [isReadOnly]="true" [label]="'Colo Referencia*'"
                        [placeholder]="'Ingrese Colo Referencia'"
                        formControlName="colorReferencia"></app-lfsa-input>
      </div>
      <div class="form-group col-md-4 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('colorDescripcion')" [id]="'colorDescripcion'"
                        [isReadOnly]="true" [label]="'Descripción*'"
                        [placeholder]="'Ingrese Descripción'"
                        formControlName="colorDescripcion"></app-lfsa-input>
      </div>
      <div class="form-group col-md-4 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="formulario.get('colorPorcentajeInicio')"
                        [id]="'colorPorcentajeInicio'" [label]="'Color Porcentaje Inicio*'"
                        [placeholder]="'Ingrese Color Porcentaje Inicio'"
                        formControlName="colorPorcentajeInicio"></app-lfsa-input>
      </div>
    </div>
    <br>
    <app-lfsa-botones-formulario (devolverAccion)="acciones ( $event )" [formularioValido]="formulario.invalid"
                                 [textBoton]="textBoton"></app-lfsa-botones-formulario>
  </form>
</ng-template>
